import styled, { css } from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PopupSetPhoneWrapper = styled.section<{
    isSelectInputable: boolean,
    useMargin?: boolean,
}>`
    display: flex;
    width: ${({ isSelectInputable }) => isSelectInputable ? '448px' : '224px'};
    gap: 12px;

    ${({ isSelectInputable }) => isSelectInputable && `
        div {
            &:last-child {
                margin-bottom: 0;
            }
        }
    `}

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        width: 100%;
    }

    /**
     * Уберет абсолюты для выпадающего списка, т.к внутри
     * попапа это не нужно
     */
    & > div {
        &:first-child {
            & > div > div {
                &:last-child {
                    position: relative;
                    margin-top: 10px !important;
                }
            }
        }

        &:last-child input {
            ${({ useMargin }) => useMargin && css`
                margin-top: 10px;
        
                @media (max-width: ${wideBreakpoints.mobile}) {
                    margin: 0;
                }
            `}
        }
    }
`;

export const PopupSetPhoneError = styled.span`
    ${FONTS.MediumXXS}
    color: ${COLORS.Error};
`;

export const PopupSetPhoneButton = styled(Button)<{ useMargin?: boolean }>`
    height: fit-content;

    ${({ useMargin }) => useMargin && css`
        margin-top: 10px;

        @media (max-width: ${wideBreakpoints.mobile}) {
            margin: 0;
        }
    `}
`;
